import styled from 'styled-components';

export const Label = styled.label`
	display: block;
	line-height: 1.75;
	font-size: 0.85rem;
	color: #333;
	span {
		font-weight: bold;
	}
`;

export const Group = styled.div`
	max-width: 410px;
	margin-bottom: 35px;
`;

export const FormInput = styled.input`
	width: 100%;
	padding: 7px 15px;
	border-radius: 3px;
	border: 2px solid transparent;
	font-size: 1rem;
	background-color: #a0a0a01f;
	&:focus {
		border-color: #333;
		box-shadow: none;
	}
`;

export const FormTextArea = styled.textarea`
	width: 100%;
	padding: 7px 15px;
	border-radius: 3px;
	border: 2px solid transparent;
	font-size: 1rem;
	background-color: #a0a0a01f;
	&:focus {
		border-color: #333;
		box-shadow: none;
	}
`;

export const Amounts = styled.div`
	display: flex;
	flex-flow: row nowrap;
	${FormInput} {
		max-width: 80px;
		margin-right: 15px;
		&:last-child {
			margin-right: 0;
		}
	}
`;

export const Button = styled.button`
	width: 100%;
	margin-top: 30px;
	padding: 14px 20px;
	font-weight: 500;
	font-size: 1rem;
	cursor: pointer;
	border-color: transparent;
	border-radius: 3px;
	background-color: #000;
	color: #fff;
	transition: opacity 0.2s ease-in;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`;

export const HelperText = styled.h4`
	margin: 0 0 25px;
	font-weight: 500;
	font-size: 0.9rem;
	span {
		text-transform: uppercase;
	}
`;

export const CharacterCount = styled.p`
	margin: 0;
	font-size: 0.7rem;
	text-align: right;
	color: #333;
`;
